import axios from 'axios'
import { VERIFICAR_PAGAMENTO_SICOOB_ENCOMENDA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

// situação do pagamento Sicoob PIX da encomenda (polling até APROVADO/CANCELADO)
export default function verificarPagamentoSicoobEncomenda (idEncomenda) {
  const url = `${URL}/encomendas/${idEncomenda}/forma-pagamento/sicoob/status`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: VERIFICAR_PAGAMENTO_SICOOB_ENCOMENDA,
        payload: response
      })
  );
}
